import React from "react";
import { Image as ImageIcon } from "lucide-react";

/**
 * Renders a real image when `src` is provided, otherwise a styled placeholder.
 */
const Placeholder = ({
  src,
  label = "",
  ratio = "4/3",
  className = "",
  small = false,
  fit = "cover",
}) => {
  if (src) {
    return (
      <div
        className={`relative w-full overflow-hidden rounded-xl border border-border/60 bg-muted/30 ${className}`}
        style={{ aspectRatio: ratio }}
      >
        <img
          src={src}
          alt={label || "Melbourne Brothels Guide"}
          loading="lazy"
          className={`h-full w-full ${fit === "contain" ? "object-contain" : "object-cover"}`}
        />
        <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-white/5" />
      </div>
    );
  }

  return (
    <div
      data-image-slot={label || "image"}
      className={`relative w-full overflow-hidden rounded-xl border border-border/60 bg-muted/40 grain ${className}`}
      style={{ aspectRatio: ratio }}
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, hsl(210 20% 96%) 0%, hsl(210 20% 93%) 100%)",
        }}
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center">
        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-primary/30 bg-primary/10">
          <ImageIcon className="h-5 w-5 text-primary" />
        </span>
        {label && !small && (
          <span className="font-serif text-base text-foreground/80 sm:text-lg">{label}</span>
        )}
      </div>
      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-white/5" />
    </div>
  );
};

export default Placeholder;
